import React, { useState, useRef } from "react";
import { useTheme } from '@mui/material/styles';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Grid, Icon, IconButton, MenuItem, Select, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import { DatePicker, YearPicker } from "@mui/x-date-pickers";
import * as dayjs from "dayjs";
import Backdrop from '@mui/material/Backdrop';
import Divider from '@mui/material/Divider';
import axios from "axios";
import SsidChartIcon from '@mui/icons-material/SsidChart';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import DownloadIcon from '@mui/icons-material/Download';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { API_URL } from "../../services/api-uri";
import { height } from "@mui/system";
import { Document, Page } from 'react-pdf';
import { Button, CardActionArea, CardActions } from '@mui/material';
import { toast } from 'react-toastify';
import CardContent from '@mui/material/CardContent';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';

import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { getCenters } from "../../actions/center";

const Statistics = () => {

    const theme = useTheme();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    console.log('21-06')

    const { centers: listCenters } = useSelector((state) => state.centers);
    const { user: currentUser } = useSelector((state) => state.auth);

    const [selectedCenterValue, setSelectedCenterValue] = React.useState(null);
    const [selectedYearValue, setSelectedYearalue] = React.useState(currentAcademicYear);


    const [file, setFile] = useState(null)
    const [fileName, setFileName] = useState("")

    console.log(selectedYearValue)

    useEffect(() => {
        if (!currentUser || currentUser == null) {
            navigate('/');
            return;
        }
        dispatch(getCenters())
    }, []);


    const handleCenterChange = (e) => {
        setFile(null)
        setSelectedCenterValue(listCenters.filter((c) => c.id == e)[0]);
    }

    const handleYearChange = (e) => {
        setFile(null)
        setSelectedYearalue(e);
    }



    const [date, setDate] = React.useState(dayjs('2022-04-07'));

    const [loading, setLoading] = React.useState(false);

    if (!currentUser) {
        return <Navigate to="/" />;
    }

    const generatePDF = async (download, menu_idx, sub_menu_id, weekNumber) => {

        setFile(null)

        if (!selectedCenterValue || selectedCenterValue.id <= 0) {
            toast.error("Please select a center");
            return;
        }

        let method = ""
        let format = "pdf"
        let fileName_ = ""
        let controller = "Documents2"

        switch (menu_idx) {
            case 1:
                method = "getOptionalExcursions"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_OptionalExcursion.pdf`;
                setFileName(fileName_);
                break;
            case 2:
                method = "getOptionalActivities"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_OptionalActivities.pdf`;
                setFileName(fileName_);
                break;
            case 3:
                method = "getBookingComparisonByAgency"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_ComparisonBooking&SalesbyAgency.pdf`;
                setFileName(fileName_);
                break;
            case 4:
                method = "getBookingComparisonByWeek"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_ComparisonBooking&SalesbyWeek.pdf`;
                setFileName(fileName_);
                break;
            case 5:
                method = "getBookingSalesByAgency"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_BookingSalesByAgency.pdf`;
                setFileName(fileName_);
                break;
            case 6:
                method = "getBookingSalesByWeek"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_BookingSalesByWeek.pdf`;
                setFileName(fileName_);
                break;
            case 7:
                format = "xlsx";
                method = "getBookingList"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_StudentList.xlsx`;
                setFileName(fileName_);
                break;
            case 8:
                format = "xlsx";
                method = "getStudentCountPerWeek"
                fileName_ = `${selectedCenterValue.abbreviation}_${new Date().toISOString().slice(0, 10)}_Week${weekNumber + 1}_Students_Count.xlsx`;
                setFileName(fileName_);
                break;
            case 9:
                format = "csv";
                method = "getBirthdayList"
                controller = "Documents"
                fileName_ = `${selectedCenterValue.abbreviation}_Birthdays.csv`;
                setFileName(fileName_);
                break;
        }

        setLoading(true)
        try {
            setLoading(true);

            const year = selectedYearValue.split('-').map(Number)[1]

            const response = sub_menu_id
                ? await axios.get(
                    API_URL + `${controller}/${method}/${year}/${selectedCenterValue.id}/${sub_menu_id}`,
                    { responseType: 'blob' }
                )
                : await axios.get(
                    API_URL + `${controller}/${method}/${year}/${selectedCenterValue.id}`,
                    { responseType: 'blob' }
                );
            const pdfBlob = new Blob([response.data], { type: `application/${format}` });
            const pdfUrl = URL.createObjectURL(pdfBlob);

            if (!download) {
                setFile(pdfUrl);
            }
            else {
                const file = new Blob([response.data], {
                    type: `application/${format}`,
                });
                const fileUrl = URL.createObjectURL(file);
                const anchor = document.createElement('a');
                anchor.href = fileUrl;
                anchor.download = `${fileName_}`;
                document.body.appendChild(anchor);
                anchor.click();
            }

            setLoading(false);

        } catch (error) {
            setLoading(false);
            toast.error(
                `An Error occured while downloading the file please try again later`,
                { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
            );
            console.error(error);
        }
    }

    function currentAcademicYear() {
        const anneeEnCours = new Date().getFullYear();
        const anneeSuivante = anneeEnCours + 1;
        return `${anneeEnCours}-${anneeSuivante}`;
    }

    // Ut

    const startYear = 2022;
    const endYear = 2050;
    const currentYear = new Date().getFullYear();
    //const academicYears = Array.from({ length: endYear - startYear + 1 }, (_, index) => `${startYear + index}-${startYear + index + 1}`);

    const academicYears = selectedCenterValue ? selectedCenterValue.yearsWithBookings.map((y) => { return `${y - 1}-${y}`; }) : []

    console.log(selectedCenterValue)

    return (
        <div className="app-container" style={{}}>
            {currentUser.type == 1 || currentUser.type == 2 ?

                <Grid container spacing={1}>
                    <Grid item xs={6} >
                        <Grid container spacing={1} p={1}>
                            <Grid item xs={12}>

                          
                                        <label>Select a centre</label>
                                        <Grid container>
                                            <Grid item xs={10}>
                                                <Select
                                                    value={selectedCenterValue ? selectedCenterValue.id : 0}
                                                    onChange={(e) => handleCenterChange(e.target.value)}
                                                    size="small"
                                                    style={{ width: '100%', textAlign: 'center' }} >

                                                    {listCenters &&
                                                        listCenters.filter((c) => c.yearsWithBookings)
                                                            .map((center) => (
                                                                <MenuItem value={center.id}>{center.name}</MenuItem>
                                                            ))}
                                                </Select>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {selectedCenterValue &&
                                                    <Select
                                                        size="small"
                                                        value={selectedYearValue}
                                                        onChange={(e) => handleYearChange(e.target.value)}>
                                                        {academicYears.map((year) => (
                                                            <MenuItem key={year} value={year}>
                                                                {year}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                }
                                            </Grid>
                                        </Grid>
                                   

                            </Grid>
                            {/* <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                views={['year']}
                                value={date}
                                onChange={(newValue) => {
                                    setDate(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField size="small" {...params} />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid> */}
                            <Grid item xs={12}>
                                {selectedCenterValue && selectedCenterValue.id > 0 && listCenters.filter((c) => c.yearsWithBookings.includes(parseInt(selectedYearValue.split('-')[1]))).some(c => c.id === selectedCenterValue.id) ?
                                    <>
                                        <Typography component="div" variant="h6" textAlign={""}>
                                            <FormatListBulletedIcon fontSize="small" sx={{ color: "primary.main" }} />
                                            Listing
                                        </Typography>
                                        <Card>
                                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                <CardContent sx={{ flex: '1 0 auto' }}>
                                                    <Typography component="div" textAlign={""}>
                                                        StudentList
                                                    </Typography>
                                                </CardContent>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 7, null) }}>
                                                        <DownloadIcon sx={{}} />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                <CardContent sx={{ flex: '1 0 auto' }}>
                                                    <Typography component="div" textAlign={""}>
                                                        Birthday List
                                                    </Typography>
                                                </CardContent>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 9, null) }}>
                                                        <DownloadIcon sx={{}} />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        </Card>
                                        <Grid container spacing={3} mt={1}>
                                            {
                                                selectedCenterValue.weeks
                                                &&
                                                selectedCenterValue.weeks.filter((week) => {
                                                    const [startYear, endYear] = selectedYearValue.split('-').map(Number);
                                                    const weekStartDate = new Date(week.startDate);
                                                    const weekYear = weekStartDate.getFullYear();
                                                    return weekYear == endYear;
                                                })
                                                    .map((week, idx) => {
                                                        return (
                                                            <Grid item xs={4}>
                                                                <Card>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                        <CardContent sx={{ flex: '1 0 auto' }}>
                                                                            <Typography component="div" textAlign={""}>
                                                                                Week {(idx + 1)} Students Count
                                                                            </Typography>
                                                                            <Typography component="div" textAlign={""}>
                                                                                {week.number}
                                                                            </Typography>
                                                                        </CardContent>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                            <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 8, week.id, idx) }}>
                                                                                <DownloadIcon sx={{}} />
                                                                            </IconButton>
                                                                        </Box>
                                                                    </Box>
                                                                </Card>
                                                            </Grid>
                                                        )
                                                    })
                                            }

                                        </Grid>

                                        <Typography component="div" variant="h6" textAlign={""} mt={2}>
                                            <LocalActivityIcon fontSize="small" sx={{ color: "primary.main" }} />
                                            Optionals
                                        </Typography>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <Card>
                                                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                        <CardContent sx={{ flex: '1 0 auto' }}>
                                                            <Typography component="div" textAlign={""}>
                                                                Optional Excursions
                                                            </Typography>
                                                        </CardContent>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 1, null) }}>
                                                                <DownloadIcon sx={{}} />
                                                            </IconButton>
                                                            <IconButton aria-label="play/pause" onClick={() => { generatePDF(false, 1, null) }}>
                                                                <RemoveRedEyeIcon sx={{}} />
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                </Card>
                                            </Grid>

                                            {
                                                selectedCenterValue.extras &&
                                                selectedCenterValue.extras
                                                    .filter((e) => e.type == 1)
                                                    .filter((obj, index, arr) => {
                                                        return new Date(obj.startDate).getFullYear() === parseInt(selectedYearValue.split('-')[1]);
                                                    })
                                                    .reduce((unique, extra) => {
                                                        if (!unique.some(obj => obj.name === extra.name)) {
                                                            unique.push(extra);
                                                        }
                                                        return unique;
                                                    }, [])
                                                    .map((extra) => {
                                                        console.log(extra)
                                                        return (
                                                            new Date(extra.startDate).getFullYear() == selectedYearValue.split('-').map(Number)[1] ?
                                                                <Grid item xs={4}>
                                                                    <Card>
                                                                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                            <CardContent sx={{ flex: '1 0 auto' }}>
                                                                                <Typography component="div" textAlign={""}>
                                                                                    Optional Activities
                                                                                </Typography>
                                                                                <Typography component="div" textAlign={""}>
                                                                                    {extra.name}
                                                                                </Typography>
                                                                            </CardContent>
                                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                                <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 2, extra.id) }}>
                                                                                    <DownloadIcon sx={{}} />
                                                                                </IconButton>
                                                                                <IconButton aria-label="play/pause" onClick={() => { generatePDF(false, 2, extra.id) }}>
                                                                                    <RemoveRedEyeIcon sx={{}} />
                                                                                </IconButton>
                                                                            </Box>
                                                                        </Box>
                                                                    </Card>
                                                                </Grid> : <></>

                                                        )
                                                    })
                                            }

                                            {currentUser.type == 1 || currentUser.id == 4 || currentUser.id == 17 || currentUser.id == 2 ?
                                                <>
                                                    <Grid item xs={12} >
                                                        <Typography component="div" variant="h6" textAlign={""}>
                                                            <SsidChartIcon fontSize="small" sx={{ color: "primary.main" }} />
                                                            Comparison & Sales
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Card>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                <CardContent sx={{ flex: '1 0 auto' }}>
                                                                    <Typography component="div" textAlign={""}>
                                                                        Comparison Booking & Sales by Agency
                                                                    </Typography>
                                                                </CardContent>
                                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 3, null) }}>
                                                                        <DownloadIcon sx={{}} />
                                                                    </IconButton>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(false, 3, null) }}>
                                                                        <RemoveRedEyeIcon sx={{}} />
                                                                    </IconButton>
                                                                </Box>
                                                            </Box>
                                                        </Card>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Card>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                <CardContent sx={{ flex: '1 0 auto' }}>
                                                                    <Typography component="div" textAlign={""}>
                                                                        Comparison Booking & Sales by Week
                                                                    </Typography>
                                                                </CardContent>
                                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 4, null) }}>
                                                                        <DownloadIcon sx={{}} />
                                                                    </IconButton>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(false, 4, null) }}>
                                                                        <RemoveRedEyeIcon sx={{}} />
                                                                    </IconButton>
                                                                </Box>
                                                            </Box>
                                                        </Card>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Card>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                <CardContent sx={{ flex: '1 0 auto' }}>
                                                                    <Typography component="div" textAlign={""}>
                                                                        Booking Sales by Agency
                                                                    </Typography>
                                                                </CardContent>
                                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 5, null) }}>
                                                                        <DownloadIcon sx={{}} />
                                                                    </IconButton>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(false, 5, null) }}>
                                                                        <RemoveRedEyeIcon sx={{}} />
                                                                    </IconButton>
                                                                </Box>
                                                            </Box>
                                                        </Card>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Card>
                                                            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                <CardContent sx={{ flex: '1 0 auto' }}>
                                                                    <Typography component="div" textAlign={""}>
                                                                        Booking Sales by Week
                                                                    </Typography>
                                                                </CardContent>
                                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(true, 6, null) }}>
                                                                        <DownloadIcon sx={{}} />
                                                                    </IconButton>
                                                                    <IconButton aria-label="play/pause" onClick={() => { generatePDF(false, 6, null) }}>
                                                                        <RemoveRedEyeIcon sx={{}} />
                                                                    </IconButton>
                                                                </Box>
                                                            </Box>
                                                        </Card>
                                                    </Grid></>
                                                : <></>}

                                        </Grid>
                                    </>
                                    : <></>
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={6} justifyContent={'center'} margin={'auto'} textAlign={'center'} sx={{ color: '#fab843' }} max-height={'500px'}>
                        {
                            file != null ?
                                <div>
                                    <DocViewer
                                        documents={[{ uri: file, fileName: fileName }]}
                                        pluginRenderers={DocViewerRenderers}
                                    />
                                </div>
                                : <>{loading ? <CircularProgress color="inherit" /> : <></>}</>
                        }

                    </Grid>

                </Grid>

                : <></>
            }

        </div >
    );
};

export default Statistics;